import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Row, Col, Button, Panel, Well, HelpBlock, Label } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import pick from 'lodash/pick';
import {
    loadRecoveryAction,
    getRecoveryActionById,
    markExecuted,
    getError,
    getIsFetching,
    getIsPending,
    editInsertManifestRecoveryAction,
    editPullForwardRecoveryAction,
    editTapRecoveryAction,
    editSlideRecoveryAction,
    editSpecialRecoveryAction,
    cancelRecoveryAction,
    assignRecoveryActionToMe,
} from '../../recoveryActionsDuck';
import RecoveryActionInfo from '../components/RecoveryActionInfo';
import AssigneeInfo from '../components/AssigneeInfo';
import ManifestsInfo from '../../../abnormalities/components/ManifestsInfo';
import CommentsInfo from '../../../abnormalities/components/CommentsInfo';
import TapInfo from '../components/TapInfo';
import ManifestTimeline from '../../../../components/ManifestTimeline/index';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import {
    composeManifestsWithMetaData,
    mapAbnormalityManifestsToSelectedManifests,
} from '../../../../shared/utils/abnormalityHelpers';
import InsertManifestInfo from '../components/InsertManifestInfo';
import SpecialInfo from '../components/SpecialInfo';
import SpecialManifestsInfo from '../../../abnormalities/components/SpecialManifestsInfo';
import AuthorizedComponent from '../../../../components/AuthorizedComponent';
import { RECOVERY_ACTIONS, ROLE_ACTIONS } from '../../../../constants';
import {
    canEditFieldAsGroupAssignee,
    canEditRecoveryAction,
} from '../../../../shared/security/isActionAuthorized';
import { determineRequiredRoleForRecoveryActionType } from '../../../../shared/security/roleDeterminator';
import Loader from '../../../../components/Loader/index';
import SmallLoader from '../../../../components/SmallLoader';
import { createRecoveryActionDetailBreadcrumb } from '../../../../shared/utils/breadcrumbs';
import { replaceArrow } from '../../../../shared/utils/string';
import { calculateDifference } from '../../../../shared/utils/lodashExtensions';
import { formatISODateTimeForBackend } from '../../../../shared/utils/date';
//import { handleRecoveryActionValidation } from '../../../../shared/utils/handleRecoveryActionValidation';

class RecoveryAction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arrivalDate: '',
            carrier: '',
            collectionDate: '',
            comment: '',
            dueDate: '',
            errors: {},
            isEditable: false,
            message: '',
            mode: '',
            showModal: false,
            tapDate: '',
            tapNumber: '',
            title: '',
            trailerIdentifier: '',
            twoWaySpecial: false,
            unloadingDate: '',
        };
    }

    componentDidMount() {
        this.props.loadRecoveryAction(this.props.recoveryActionId);
        this.showSaveButton = false;

        if (canEditRecoveryAction(this.props.recoveryActionType)) {
            this.setState(() => ({ isEditable: true }));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.recoveryAction !== nextProps.recoveryAction &&
            nextProps.recoveryAction !== null
        ) {
            this.setState({
                comment: nextProps.recoveryAction.comment || '',
            });
            if (nextProps.recoveryAction.tapDate) {
                this.setState({
                    tapDate: moment(nextProps.recoveryAction.tapDate),
                });
            }
            if (nextProps.recoveryAction.tapNumber) {
                this.setState({
                    tapNumber: nextProps.recoveryAction.tapNumber,
                });
            }
            if (nextProps.recoveryAction.dueDate) {
                this.setState({
                    dueDate: moment(nextProps.recoveryAction.dueDate),
                });
            }
            if (nextProps.recoveryAction.arrivalDate) {
                this.setState({
                    arrivalDate: moment(nextProps.recoveryAction.arrivalDate),
                });
            }
            if (nextProps.recoveryAction.unloadingDate) {
                this.setState({
                    unloadingDate: moment(nextProps.recoveryAction.unloadingDate),
                });
            }
            if (nextProps.recoveryAction.collectionDate) {
                this.setState({
                    collectionDate: moment(nextProps.recoveryAction.collectionDate),
                });
            }
            if (nextProps.recoveryAction.trailerIdentifier) {
                this.setState({
                    trailerIdentifier: nextProps.recoveryAction.trailerIdentifier,
                });
            }
            if (nextProps.recoveryAction.carrier) {
                this.setState({
                    carrier: nextProps.recoveryAction.carrier,
                });
            }
            this.setState({
                twoWaySpecial: nextProps.recoveryAction.twoWaySpecial,
            });
        }
    }

    handleMarkExecuted = () => {
        this.setState({
            showModal: true,
            title: 'Mark recovery action executed',
            message: 'Are you sure you want to mark this recovery action as executed?',
            mode: 'markExecutedRecoveryAction',
        });
    };

    handleCancelRecoveryAction = () => {
        this.setState({
            showModal: true,
            title: 'Cancel recovery action',
            message: 'Are you sure you want to cancel this recovery action?',
            mode: 'cancelRecoveryAction',
        });
    };

    handleUpdateRecoveryAction = () => {
        this.setState({
            showModal: true,
            title: 'Update recovery action',
            message: 'Are you sure you want to update this recovery action with these changes?',
            mode: 'updateRecoveryAction',
        });
    };

    handleChange = e => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.showSaveButton = true;
        this.setState({ [name]: value });
    };

    handleDateChange = name => momentDate => {
        this.showSaveButton = true;
        this.setState({ [name]: momentDate });
    };

    handleCloseModal = () => {
        this.setState({
            showModal: false,
            title: '',
            message: '',
            mode: '',
            formData: {},
        });
    };

    handleAssignRecoveryAction = (recoveryActionId, abnormalityId) => {
        // Recovery action data gets refetched when successfully assigning it (see action creator)
        this.props.assignRecoveryActionToMe(recoveryActionId, abnormalityId);
    };

    handleConfirmModal = mode => {
        switch (mode) {
            case 'cancelRecoveryAction':
                this.props.cancelRecoveryAction({
                    recoveryActionId: this.props.recoveryActionId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'markExecutedRecoveryAction':
                this.props.markExecuted({
                    recoveryActionId: this.props.recoveryActionId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'updateRecoveryAction':
                if (this.props.recoveryActionType === RECOVERY_ACTIONS.INSERT_MANIFEST) {
                    const { dueDate } = this.state;
                    const insertManifestData = {
                        abnormalityId: this.props.abnormalityId,
                        recoveryActionId: this.props.recoveryActionId,
                        comment: this.state.comment,
                        dueDate: dueDate.toISOString(),
                    };
                    this.props.editInsertManifestRecoveryAction(insertManifestData);
                } else if (this.props.recoveryActionType === RECOVERY_ACTIONS.PULL_FORWARD) {
                    const { dueDate } = this.state;
                    const pullForwardData = {
                        abnormalityId: this.props.abnormalityId,
                        recoveryActionId: this.props.recoveryActionId,
                        comment: this.state.comment,
                        dueDate: dueDate.toISOString(),
                    };
                    this.props.editPullForwardRecoveryAction(pullForwardData);
                } else if (this.props.recoveryActionType === RECOVERY_ACTIONS.TAP) {
                    const { dueDate, tapDate, tapNumber } = this.state;
                    const tapData = {
                        abnormalityId: this.props.abnormalityId,
                        recoveryActionId: this.props.recoveryActionId,
                        comment: this.state.comment,
                        dueDate: dueDate.toISOString(),
                        tapDate: tapDate.toISOString(),
                        tapNumber: tapNumber,
                    };
                    this.props.editTapRecoveryAction(tapData);
                } else if (this.props.recoveryActionType === RECOVERY_ACTIONS.SLIDE) {
                    const { dueDate } = this.state;
                    const slideData = {
                        abnormalityId: this.props.abnormalityId,
                        recoveryActionId: this.props.recoveryActionId,
                        comment: this.state.comment,
                        dueDate: dueDate.toISOString(),
                    };
                    this.props.editSlideRecoveryAction(slideData);
                } else if (this.props.recoveryActionType === RECOVERY_ACTIONS.SPECIAL) {
                    // Using formatISODateTimeForBackend because backend's date format is slightly different than ours :(
                    const specialData = {
                        abnormalityId: this.props.abnormalityId,
                        recoveryActionId: this.props.recoveryActionId,
                        arrivalDate: this.state.arrivalDate
                            ? formatISODateTimeForBackend(this.state.arrivalDate)
                            : null,
                        carrier: this.state.carrier,
                        collectionDate: this.state.collectionDate
                            ? formatISODateTimeForBackend(this.state.collectionDate)
                            : null,
                        comment: this.state.comment,
                        dueDate: this.state.dueDate
                            ? formatISODateTimeForBackend(this.state.dueDate)
                            : null,
                        trailerIdentifier: this.state.trailerIdentifier,
                        twoWaySpecial: this.state.twoWaySpecial,
                        unloadingDate: this.state.unloadingDate
                            ? formatISODateTimeForBackend(this.state.unloadingDate)
                            : null,
                    };

                    const originalData = pick(this.props.recoveryAction, [
                        ...Object.keys(specialData),
                    ]);
                    const difference = calculateDifference(specialData, originalData);
                    // Difference must include abn. ID and rec. action
                    difference.abnormalityId = this.props.abnormalityId;
                    difference.recoveryActionId = this.props.recoveryActionId;
                    console.log('Form data changes', difference);

                    // Uncomment import too
                    //const errors = handleRecoveryActionValidation(difference);
                    //this.setState({ errors });

                    this.props.editSpecialRecoveryAction(difference);
                    this.handleCloseModal();
                    return;
                }
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            default:
                return;
        }
    };

    redirect = () => {
        const { router, runId, abnormalityType, abnormalityId } = this.props;
        router.push(`/runs/${runId}/abnormality/${abnormalityType}/${abnormalityId}/`);
    };

    isEditableByGroupAssignee = recoveryAction => {
        if (recoveryAction && recoveryAction.recoveryActionType === RECOVERY_ACTIONS.SPECIAL) {
            return (
                this.state.isEditable ||
                canEditFieldAsGroupAssignee(recoveryAction.groupRoleAssignees)
            );
        }
        return this.state.isEditable;
    };

    render() {
        const {
            recoveryAction,
            isFetching,
            isPending,
            runId,
            abnormalityId,
            abnormalityType,
        } = this.props;
        const {
            errors,
            tapDate,
            tapNumber,
            comment,
            dueDate,
            showModal,
            title,
            message,
            mode,
            isEditable,
        } = this.state;

        if (isFetching || recoveryAction === null) {
            return <Loader />;
        }

        return (
            <Row>
                {recoveryAction &&
                    createRecoveryActionDetailBreadcrumb(recoveryAction, abnormalityType)}
                <Col sm={12}>
                    <Row>
                        <Col sm={4}>
                            <Row>
                                <Col sm={12}>
                                    <RecoveryActionInfo
                                        type={recoveryAction && recoveryAction.recoveryActionType}
                                        status={recoveryAction && recoveryAction.status}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={4}>
                            <Row>
                                <Col sm={12}>
                                    <AssigneeInfo
                                        details
                                        assignee={recoveryAction && recoveryAction.assignee}
                                        assigneeGroup={
                                            recoveryAction && recoveryAction.groupRoleAssignees
                                        }
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={2}>
                            {recoveryAction &&
                                recoveryAction.updatedByTlms && (
                                    <Label bsStyle="danger" className="pull-right">
                                        NEEDS VALIDATION
                                    </Label>
                                )}
                            {recoveryAction && (
                                <AuthorizedComponent
                                    requiredRoles={[
                                        determineRequiredRoleForRecoveryActionType(
                                            recoveryAction.recoveryActionType,
                                            ROLE_ACTIONS.EXECUTOR
                                        ),
                                    ]}
                                >
                                    <Button
                                        bsStyle="primary"
                                        style={{
                                            width: '100%',
                                            marginBottom: 15,
                                            whiteSpace: 'normal',
                                        }}
                                        onClick={() =>
                                            this.handleAssignRecoveryAction(
                                                recoveryAction && recoveryAction.recoveryActionId,
                                                abnormalityId
                                            )
                                        }
                                    >
                                        Assign to me
                                    </Button>
                                </AuthorizedComponent>
                            )}
                        </Col>
                        {recoveryAction &&
                            recoveryAction.status !== 'EXECUTED' &&
                            recoveryAction.status !== 'CANCELLED' && (
                                <Col sm={2}>
                                    <AuthorizedComponent
                                        requiredRoles={[
                                            determineRequiredRoleForRecoveryActionType(
                                                recoveryAction.recoveryActionType,
                                                ROLE_ACTIONS.EXECUTOR
                                            ),
                                        ]}
                                    >
                                        <Button
                                            bsStyle="success"
                                            style={{
                                                width: '100%',
                                                marginBottom: 15,
                                                whiteSpace: 'normal',
                                            }}
                                            onClick={this.handleMarkExecuted}
                                        >
                                            Mark as executed
                                        </Button>
                                    </AuthorizedComponent>
                                    <AuthorizedComponent
                                        requiredRoles={[
                                            determineRequiredRoleForRecoveryActionType(
                                                recoveryAction.recoveryActionType,
                                                ROLE_ACTIONS.EDITOR
                                            ),
                                        ]}
                                    >
                                        <Button
                                            bsStyle="danger"
                                            style={{
                                                width: '100%',
                                                whiteSpace: 'normal',
                                            }}
                                            onClick={this.handleCancelRecoveryAction}
                                        >
                                            Cancel recovery action
                                        </Button>
                                    </AuthorizedComponent>
                                </Col>
                            )}
                    </Row>

                    <Row>
                        {recoveryAction &&
                            recoveryAction.recoveryActionType !==
                                RECOVERY_ACTIONS.INSERT_MANIFEST &&
                            recoveryAction.manifestGroups &&
                            recoveryAction.manifestGroups.map((manifestGroup, index) => {
                                const manifests = composeManifestsWithMetaData(
                                    manifestGroup.manifests
                                );
                                const selectedManifests = mapAbnormalityManifestsToSelectedManifests(
                                    manifestGroup.manifests,
                                    []
                                );

                                return (
                                    <Col key={index} sm={12}>
                                        <Well>
                                            <h4>
                                                Manifest group {replaceArrow(manifestGroup.name)}
                                            </h4>
                                            <Row>
                                                <Col sm={12}>
                                                    <Panel>
                                                        <ManifestTimeline
                                                            plannedRun={manifestGroup.plannedRun}
                                                            nextRun={manifestGroup.nextRun}
                                                        />
                                                    </Panel>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <ManifestsInfo
                                                        url={{
                                                            runId: runId,
                                                            abnormalityId: abnormalityId,
                                                            abnormalityType: abnormalityType,
                                                        }}
                                                        isEditable={false}
                                                        isSelectable={false}
                                                        recoveryActionDetails={true}
                                                        manifests={manifests}
                                                        selectedManifests={selectedManifests}
                                                        validations={{}}
                                                    />
                                                </Col>
                                            </Row>
                                        </Well>
                                    </Col>
                                );
                            })}
                    </Row>
                    {recoveryAction &&
                        recoveryAction.recoveryActionType === 'SPECIAL' && (
                            <div>
                                <Row>
                                    <Col sm={12}>
                                        <Panel>
                                            <SpecialManifestsInfo
                                                abnormalityManifests={
                                                    recoveryAction.abnormalityManifests
                                                }
                                            />
                                        </Panel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Well>
                                            <SpecialInfo
                                                isEditable={this.state.isEditable}
                                                isEditableByGroupAssignee={this.isEditableByGroupAssignee(
                                                    recoveryAction
                                                )}
                                                errors={errors}
                                                fields={this.state}
                                                recoveryAction={recoveryAction}
                                                handleChange={this.handleChange}
                                                handleDateChange={this.handleDateChange}
                                            />
                                        </Well>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    {recoveryAction &&
                        recoveryAction.recoveryActionType === RECOVERY_ACTIONS.INSERT_MANIFEST && (
                            <div>
                                <Row>
                                    {recoveryAction.manifestGroups &&
                                        recoveryAction.manifestGroups.map(
                                            (manifestGroup, index) => {
                                                return (
                                                    <Col key={index} sm={12}>
                                                        <Well>
                                                            <h4>
                                                                Manifest group{' '}
                                                                {replaceArrow(manifestGroup.name)}
                                                            </h4>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <Panel>
                                                                        <ManifestTimeline
                                                                            plannedRun={
                                                                                manifestGroup.plannedRun
                                                                            }
                                                                        />
                                                                    </Panel>
                                                                </Col>
                                                            </Row>
                                                        </Well>
                                                    </Col>
                                                );
                                            }
                                        )}
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Panel>
                                            <SpecialManifestsInfo
                                                abnormalityManifests={
                                                    recoveryAction.manifestGroups.length > 0
                                                        ? recoveryAction.manifestGroups[0].manifests
                                                        : []
                                                }
                                                showNumberOfPallets
                                            />
                                        </Panel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Well>
                                            <InsertManifestInfo recoveryAction={recoveryAction} />
                                        </Well>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    {recoveryAction &&
                        (recoveryAction.recoveryActionType === RECOVERY_ACTIONS.SLIDE ||
                            recoveryAction.recoveryActionType ===
                                RECOVERY_ACTIONS.PULL_FORWARD) && (
                            <Row>
                                <Col sm={12}>
                                    <Well>
                                        <Row>
                                            <Col sm={4}>
                                                <Row>
                                                    <Col
                                                        sm={4}
                                                        style={{
                                                            marginTop: 10,
                                                        }}
                                                    >
                                                        <p>
                                                            {recoveryAction.recoveryActionType ===
                                                            RECOVERY_ACTIONS.SLIDE
                                                                ? 'Slide'
                                                                : 'Pull'}{' '}
                                                            from
                                                        </p>
                                                    </Col>
                                                    <Col sm={8}>
                                                        <p
                                                            style={{
                                                                marginTop: 5,
                                                            }}
                                                        >
                                                            {recoveryAction &&
                                                            recoveryAction.originRun
                                                                ? recoveryAction.originRun
                                                                      .readableId
                                                                : '-'}
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col
                                                        sm={4}
                                                        style={{
                                                            marginTop: 10,
                                                        }}
                                                    >
                                                        <p>
                                                            {recoveryAction.recoveryActionType ===
                                                            RECOVERY_ACTIONS.SLIDE
                                                                ? 'Slide'
                                                                : 'Pull'}{' '}
                                                            to
                                                        </p>
                                                    </Col>
                                                    <Col sm={8}>
                                                        <p
                                                            style={{
                                                                marginTop: 5,
                                                            }}
                                                        >
                                                            {recoveryAction && recoveryAction.newRun
                                                                ? recoveryAction.newRun.readableId
                                                                : '-'}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Well>
                                </Col>
                            </Row>
                        )}
                    <Row>
                        <Col sm={12}>
                            <Well>
                                <Row>
                                    <Col sm={4}>
                                        <Row>
                                            <Col sm={4} style={{ marginTop: 10 }}>
                                                <p>Due date</p>
                                            </Col>
                                            <Col sm={8}>
                                                {!isEditable && (
                                                    <p
                                                        style={{
                                                            marginTop: 5,
                                                        }}
                                                    >
                                                        {moment(dueDate).format(
                                                            'DD-MM-YYYY HH:mm'
                                                        ) || '-'}
                                                    </p>
                                                )}
                                                {isEditable && (
                                                    <Datetime
                                                        value={dueDate}
                                                        onChange={this.handleDateChange('dueDate')}
                                                        dateFormat="DD-MM-YYYY"
                                                        timeFormat="HH:mm"
                                                        inputProps={{
                                                            maxLength: 255,
                                                        }}
                                                        className={
                                                            errors.dueDate && 'datetime-error'
                                                        }
                                                    />
                                                )}
                                                {errors.dueDate && (
                                                    <HelpBlock>
                                                        <span className="text-danger">
                                                            {errors.dueDate}
                                                        </span>
                                                    </HelpBlock>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Well>
                        </Col>
                    </Row>
                    {recoveryAction &&
                        recoveryAction.recoveryActionType === 'TAP' && (
                            <Row>
                                <Col sm={12}>
                                    <Well>
                                        <TapInfo
                                            isEditable={
                                                recoveryAction.recoveryActionType ===
                                                RECOVERY_ACTIONS.INSERT_MANIFEST
                                                    ? false
                                                    : isEditable
                                            }
                                            tapDate={tapDate}
                                            tapNumber={tapNumber}
                                            onChange={this.handleChange}
                                            onDateChange={this.handleDateChange}
                                        />
                                    </Well>
                                </Col>
                            </Row>
                        )}
                    <Row>
                        <Col sm={12}>
                            <CommentsInfo
                                isEditable={this.isEditableByGroupAssignee(recoveryAction)}
                                comment={comment}
                                onCommentChange={this.handleChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Button
                                className="pull-right"
                                bsStyle="primary"
                                onClick={this.handleUpdateRecoveryAction}
                                disabled={!isEditable && !this.showSaveButton}
                            >
                                {isPending ? <SmallLoader tiny noMargin /> : 'Save changes'}
                            </Button>
                        </Col>
                    </Row>
                </Col>
                {showModal && (
                    <ConfirmationModal
                        showModal={showModal}
                        title={title}
                        message={message}
                        mode={mode}
                        onConfirm={this.handleConfirmModal}
                        onClose={this.handleCloseModal}
                    />
                )}
            </Row>
        );
    }
}

const mapStateToProps = (state, props) => ({
    recoveryAction: getRecoveryActionById(state, props.recoveryActionId),
    isFetching: getIsFetching(state),
    isPending: getIsPending(state),
    error: getError(state),
});

const mapDispatchToProps = dispatch => ({
    loadRecoveryAction: bindActionCreators(loadRecoveryAction, dispatch),
    markExecuted: bindActionCreators(markExecuted, dispatch),
    editPullForwardRecoveryAction: bindActionCreators(editPullForwardRecoveryAction, dispatch),
    editTapRecoveryAction: bindActionCreators(editTapRecoveryAction, dispatch),
    editSlideRecoveryAction: bindActionCreators(editSlideRecoveryAction, dispatch),
    editSpecialRecoveryAction: bindActionCreators(editSpecialRecoveryAction, dispatch),
    editInsertManifestRecoveryAction: bindActionCreators(
        editInsertManifestRecoveryAction,
        dispatch
    ),
    cancelRecoveryAction: bindActionCreators(cancelRecoveryAction, dispatch),
    assignRecoveryActionToMe: bindActionCreators(assignRecoveryActionToMe, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecoveryAction));
